import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {GetFileType, mediaPreviewUrl, mediaUrl} from '../../helpers/Helpers.js';
import {
    get as getMedia,
    setMediaItemForDelete,
    setMediaItemForEdit,
    selectMediaItems
} from '../../store/actions/media';
import {get as getWorkspaces} from '../../../store/actions/workspace';
import {classNamesPrefixed} from '../../../helpers/CoreHelpers';
import Btn from './Btn';
import moment from 'moment';
import _ from 'lodash';

class MediaItem extends Component {
    static propTypes = {
        maxSelectItems: PropTypes.number,
        deleteEnabled: PropTypes.bool,
        editEnabled: PropTypes.bool,
        item: PropTypes.object.isRequired
    };

    static defaultProps = {
        maxSelectItems: null,
        deleteEnabled: false,
        editEnabled: false
    };

    constructor(props) {
        super(props);

        this.state = {
            clickableThumbnail: props.clickableThumbnail
        };
    }

    isActive(id) {
        return _.find(this.props.media.selectedMediaItems, {id: id});
    }

    clearItems() {
        return this.props.selectMediaItems([]);
    }

    selectItem(event, item, select) {
        let x = null;
        let newSelectedItems = null;
        const selectedItems = this.props.media.selectedMediaItems;

        if (select) {
            newSelectedItems = [];

            if (selectedItems) {
                newSelectedItems = selectedItems;
            }

            newSelectedItems.push(item);
        } else {
            newSelectedItems = [];

            for (x in selectedItems) {
                if (parseInt(selectedItems[x].id, 10) !== parseInt(item.id, 10)) {
                    newSelectedItems.push(selectedItems[x]);
                }
            }
        }


        this.props.selectMediaItems(newSelectedItems);
    }

    toggleSelected(event) {
        event.preventDefault();
        event.stopPropagation();

        const {item, maxSelectItems, selectEnabled} = this.props;
        const selectedItems = this.props.media.selectedMediaItems;
        const select = !_.find(selectedItems, {id: item.id});

        if (selectEnabled) {
            if (maxSelectItems === null) {
                return this.selectItem(event, item, select);
            } else if (maxSelectItems === 1) {
                return this.clearItems().then(() => {
                    return this.selectItem(event, item, select);
                });
            } else {
                if (selectedItems.length < maxSelectItems) {
                    return this.selectItem(event, item, select);
                } else {
                    return this.selectItem(event, item, select);
                }
            }
        }
    }

    onDelete(event, id) {
        event.stopPropagation();
        event.preventDefault();

        if (this.props.deleteEnabled) {
            if (typeof (this.props.onDelete) === "function") {
                this.props.onDelete(event, id);
            } else {
                this.props.setMediaItemForDelete(id);
            }
        }
    }

    onEdit(event, id) {
        event.preventDefault();
        if (this.props.onEdit) {
            this.props.onEdit(event, id);
        } else {
            if (this.props.editEnabled) {
                this.props.setMediaItemForEdit(id);
                event.stopPropagation();
            }
        }
    }

    onThumbClick(event, item) {
        if (!this.state.clickableThumbnail) {
            return;
        }

        if (!this.props.editEnabled) {
            window.open(item.preview ? item.preview : mediaUrl(item), "_blank");
        } else {
            this.onEdit(event, item.id);
        }
    }

    render() {
        const {clickableThumbnail} = this.state;
        const {item, deleteEnabled, editEnabled} = this.props;

        if (item.preview || item.ref) {
            const fileType = GetFileType(item.fileName ? item.fileName : item.name);
            const styles = {};

            if (clickableThumbnail) {
                styles.cursor = 'pointer';
            }

            if (fileType.id === 'images') {
                if (fileType.ext === 'svg') {
                    styles.backgroundImage = `url(${item.fileName ? mediaUrl(item) : item.preview})`;
                } else {
                    styles.backgroundImage = `url(${item.fileName ? mediaPreviewUrl(item, 400, 400) : item.preview})`;
                }
            }

            return (
                <div
                    onClick={(event) => this.toggleSelected(event)}
                    className={classNamesPrefixed({
                        'media-item': true,
                        ['media-type-' + fileType.id]: true,
                        ['media-type-ext-' + fileType.ext]: true,
                        'selected': this.isActive(item.id)
                    })}
                >
                    <div
                        style={styles}
                        className={classNamesPrefixed({
                            'media-content': true,
                            'no-preview': fileType.id !== 'images'
                        })}
                        onClick={(event) => this.onThumbClick(event, item)}
                    >
                        <div
                            className={classNamesPrefixed({'media-actions': true,})}>
                            <div
                                className={classNamesPrefixed({'media-title': true})}>
                                <h3>{item.title ? item.title : item.fileName}</h3>
                                <time>{moment(item.updated).format("YYYY-MM-DD")}</time>
                            </div>
                            <div
                                className={classNamesPrefixed({'media-buttons': true})}>
                                {editEnabled &&
                                <Btn icon="pen" type='fas'
                                     onClick={(event) => this.onEdit(event, item.id)}/>
                                }
                                {deleteEnabled &&
                                <Btn icon="trash" type='fas'
                                     onClick={(event) => this.onDelete(event, item.id)}/>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return null;
    }
}

const mapStateToProps = (state) => {
    return {
        media: state.media,
        workspace: state.workspace
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getMedia: () => dispatch(getMedia()),
        setMediaItemForDelete: (id) => dispatch(setMediaItemForDelete(id)),
        setMediaItemForEdit: (id) => dispatch(setMediaItemForEdit(id)),
        getWorkspaces: () => dispatch(getWorkspaces()),
        selectMediaItems: (items) => dispatch(selectMediaItems(items)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MediaItem)



// WEBPACK FOOTER //
// ./src/core/admin/components/UI/MediaItem.js